/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userOffers.internal

import features.userOffers.models.UserOffersModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserOffersRequest : NetworkRequest() {

    suspend fun getUserOffers(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<UserOffersModel> {
        return safeNetworkCall {
            get(
                endpoint = UserOffersEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
